"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.swipeableHOC = void 0;
var react_1 = __importStar(require("react"));
var component_1 = require("../../helpers/component");
var swipeableHOC = function (WrappedComponent) {
    var Swipeable = function (_a) {
        var _b = _a.minMoveX, minMoveX = _b === void 0 ? 20 : _b, _c = _a.minMoveY, minMoveY = _c === void 0 ? 20 : _c, _d = _a.onSwipeLeft, onSwipeLeft = _d === void 0 ? function () { return null; } : _d, _e = _a.onSwipeRight, onSwipeRight = _e === void 0 ? function () { return null; } : _e, _f = _a.onSwipeUp, onSwipeUp = _f === void 0 ? function () { return null; } : _f, _g = _a.onSwipeDown, onSwipeDown = _g === void 0 ? function () { return null; } : _g, rest = __rest(_a, ["minMoveX", "minMoveY", "onSwipeLeft", "onSwipeRight", "onSwipeUp", "onSwipeDown"]);
        var _h = react_1.useState({
            startX: 0,
            startY: 0,
            isMoving: false
        }), state = _h[0], setState = _h[1];
        var cancelTouch = react_1.useCallback(function () {
            setState({
                startX: 0,
                startY: 0,
                isMoving: false
            });
        }, [setState]);
        var onTouchMove = function (event) {
            var isMoving = state.isMoving, startX = state.startX, startY = state.startY;
            if (isMoving) {
                var x = event.touches[0].pageX;
                var y = event.touches[0].pageY;
                var dx = startX - x;
                var dy = startY - y;
                if (Math.abs(dx) >= minMoveX) {
                    cancelTouch();
                    if (dx > 0) {
                        onSwipeLeft(event);
                    }
                    else {
                        onSwipeRight(event);
                    }
                }
                else if (Math.abs(dy) >= minMoveY) {
                    cancelTouch();
                    if (dy > 0) {
                        onSwipeDown(event);
                    }
                    else {
                        onSwipeUp(event);
                    }
                }
            }
        };
        var onTouchStart = function (event) {
            if (event.touches.length === 1) {
                setState({
                    startX: event.touches[0].pageX,
                    startY: event.touches[0].pageY,
                    isMoving: true
                });
            }
        };
        return (react_1["default"].createElement(WrappedComponent, __assign({ onTouchStart: onTouchStart, onTouchMove: onTouchMove }, rest)));
    };
    return component_1.hoist(Swipeable, WrappedComponent);
};
exports.swipeableHOC = swipeableHOC;
exports["default"] = exports.swipeableHOC;
//# sourceMappingURL=swipeable.js.map